import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Checkbox,
	Chip,
	IconButton,
	Button,
	Menu,
	MenuItem,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import styles from './UserArchiveTable.module.scss';
import { ReactComponent as UnArchiveIcon } from '../../../../assets/icons/unarchive-blue.svg';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import DeleteIcon from '@mui/icons-material/Delete';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { openModal } from '../../../../redux/modals/action';
import {
	getUserByUserId,
	getProjectListById,
	getClickedUser,
} from '../../../../redux/userManagement/actions';
import CustomizationTooltip from '../../UserListSection/customizationTooltip/CustomizationTooltip';

const UserArchiveTable = (props) => {
	const {
		archivedUsers,
		openModal,
		setUserSelected,
		getUserByUserId,
		getProjectListById,
		getClickedUser,
		roles,
		projectSelectedCode,
		openDeleteUsersConfirmation,
		openUnarchiveUsersConfirmation,
	} = props;

	const [rows, setRows] = useState();
	const [selected, setSelected] = useState([]);
	const [selectedAll, setSelectedAll] = useState(false);
	const [anchorFilter, setAnchorFilter] = useState(null);
	const [filterByRole, setFilterByRole] = useState('');

	useEffect(() => {
		const filtered = archivedUsers
			?.filter((archivedUser) => {
				if (
					archivedUser?.projectRoles &&
					archivedUser?.projectRoles[projectSelectedCode]
				) {
					return true;
				} else {
					return false;
				}
			})
			?.filter((archivedUser) => {
				if (!filterByRole) {
					return true;
				} else {
					return archivedUser?.roles?.find(
						(role) => role.id === filterByRole
					);
				}
			});
		setRows(filtered);
	}, [archivedUsers, projectSelectedCode, filterByRole]);

	useEffect(() => {
		if (rows) {
			let userIds = rows.map((row) => row.id);
			let newSelected = [...selected];
			selected.forEach((id, index) => {
				if (!userIds.includes(id)) {
					newSelected.splice(index, 1);
				}
			});
			setSelected(newSelected);
			if (newSelected.length === 0) {
				setSelectedAll(false);
			}
		}
	}, [rows]);

	const open = Boolean(anchorFilter);

	const handleOpenFilter = (event) => {
		setAnchorFilter(event.currentTarget);
	};

	const handleCloseFilter = () => {
		setAnchorFilter(null);
	};

	const handleClickMenuItem = (id) => {
		handleCloseFilter();
		setFilterByRole(id);
	};

	const handleClickTopRadioBtn = (event) => {
		setSelectedAll(event.target.checked);
		if (event.target.checked) {
			const newSelecteds = archivedUsers?.map((n) => n?.id);
			setSelected(newSelecteds);
			return;
		}
		setSelected([]);
	};

	const handleClickRadioBtn = (event, name) => {
		const selectedIndex = selected.indexOf(name);
		let newSelected = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(selected, name);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(selected.slice(1));
		} else if (selectedIndex === selected.length - 1) {
			newSelected = newSelected.concat(selected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				selected.slice(0, selectedIndex),
				selected.slice(selectedIndex + 1)
			);
		}

		setSelected(newSelected);
	};

	const handleEditUser = (userId) => {
		openModal('addUserMgmt');
		setUserSelected(userId);
		getUserByUserId(userId);
		getProjectListById(userId);
	};

	const handleUnarchiveUsers = async () => {
		openUnarchiveUsersConfirmation(selected);
	};

	const handleUserDetails = (userId) => {
		getClickedUser(userId);
	};

	const handleDeleteUsers = () => {
		openDeleteUsersConfirmation(selected);
	};

	const isSelected = (name) => selected.indexOf(name) !== -1;

	return (
		<div className={styles.user_archive_table}>
			<TableContainer component={Paper}>
				<Table>
					<caption>{rows?.length} Users</caption>
					<TableHead>
						<TableRow>
							<TableCell padding='checkbox'>
								<Checkbox
									sx={{
										'&.Mui-checked': {
											color: 'var(--primary)',
										},
									}}
									onChange={handleClickTopRadioBtn}
									checkedIcon={<IndeterminateCheckBoxIcon />}
									checked={selectedAll}
								/>
							</TableCell>
							<TableCell>Name</TableCell>
							<TableCell>Roles</TableCell>
							<TableCell align='right'>
								{selected.length === 0 ? (
									<>
										<Button
											className={styles.filter_btn}
											endIcon={
												<KeyboardArrowDownIcon
													className={
														styles.filter_btn_icon
													}
												/>
											}
											onClick={handleOpenFilter}
										>
											Filter
										</Button>
										<Menu
											id='filter'
											anchorEl={anchorFilter}
											open={open}
											onClose={handleCloseFilter}
											MenuListProps={{
												'aria-labelledby':
													'filter-dropdown',
											}}
										>
											<MenuItem
												onClick={() =>
													handleClickMenuItem('')
												}
												style={{
													paddingRight: '50px',
												}}
											>
												All
											</MenuItem>
											{roles?.map((role, index) => (
												<>
													<hr />
													<MenuItem
														onClick={() =>
															handleClickMenuItem(
																role.roleId
															)
														}
														key={index}
														style={{
															paddingRight:
																'50px',
														}}
													>
														{role.roleName}
													</MenuItem>
												</>
											))}
										</Menu>
									</>
								) : (
									<>
										<CustomizationTooltip title='Unarchive'>
											<IconButton
												aria-label='unarchive'
												onClick={handleUnarchiveUsers}
												style={{ marginRight: '10px' }}
											>
												<UnArchiveIcon />
											</IconButton>
										</CustomizationTooltip>
										<CustomizationTooltip title='Delete'>
											<IconButton
												aria-label='delete'
												onClick={handleDeleteUsers}
											>
												<DeleteIcon
													className={
														styles.delete_icon
													}
												/>
											</IconButton>
										</CustomizationTooltip>
									</>
								)}
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{rows?.map((archivedUser) => {
							const isItemSelected = isSelected(archivedUser.id);

							return (
								<TableRow
									key={archivedUser.id}
									hover
									selected={isItemSelected}
								>
									<TableCell padding='checkbox'>
										<Checkbox
											sx={{
												'&.Mui-checked': {
													color: 'var(--primary)',
												},
											}}
											checked={isItemSelected}
											onClick={(event) =>
												handleClickRadioBtn(
													event,
													archivedUser.id
												)
											}
										/>
									</TableCell>
									<TableCell>
										<div
											onClick={() =>
												handleUserDetails(
													archivedUser.id
												)
											}
											className={styles.name_field}
										>
											{archivedUser.fullName}
										</div>
									</TableCell>
									<TableCell>
										{archivedUser?.roles?.map(
											(role, index) => (
												<Chip
													label={role.name}
													key={index}
													color='primary'
													className={styles.role_chip}
													style={{
														backgroundColor: `${role.color}`,
													}}
												/>
											)
										)}
									</TableCell>
									<TableCell align='right'>
										<IconButton
											aria-label='edit'
											onClick={() =>
												handleEditUser(archivedUser.id)
											}
										>
											<EditIcon
												className={styles.edit_icon}
											/>
										</IconButton>
									</TableCell>
								</TableRow>
							);
						})}
					</TableBody>
				</Table>
			</TableContainer>
		</div>
	);
};

const mapStateToProps = (state) => ({
	archivedUsers: state.userManagement.archivedUsers,
	roles: state.userManagement.roles,
	projectSelectedCode: state.userManagement.projectSelectedCode,
});

export default connect(mapStateToProps, {
	openModal,
	getUserByUserId,
	getProjectListById,
	getClickedUser,
})(UserArchiveTable);
